import React, { FunctionComponent, Fragment } from "react";
import { Button } from "reactstrap";
import styled from "styled-components";
import { drawExistingWall } from "../helpers/revitClient";

const Message = styled.p`
  margin: 0 !important;
`;

const DrawButton = styled(Button)`
  color: white !important;
  padding: 0 !important;
  margin-bottom: 0.2rem;
`;

interface IProps {
  modelNumber: string;
}

const RevitAlert: FunctionComponent<IProps> = ({ modelNumber }) => {
  return (
    <Fragment>
      <b>Buildup already exists.</b>
      <br />
      <DrawButton onClick={() => drawExistingWall(modelNumber)} color="link">
        Click here to start drawing
      </DrawButton>
    </Fragment>
  );
};

export default RevitAlert;
